// extracted by mini-css-extract-plugin
module.exports = {"container":"why-join_container__1wxtV","box":"why-join_box__2HFPi","boxTitle":"why-join_boxTitle__8d2_9","boxDesc":"why-join_boxDesc__3MIB0","FirstBox":"why-join_FirstBox__3HwJP"};